import { ActivatedRoute } from '@angular/router';
import { Place, PlaceSelectors } from '@app/entities/place';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { InputDestinationPlace } from '@shared/base-search-bar/entities/autocomplete-destionation';
import { SearchType } from '@search-bar/entities/search-type';
import { HotelFilterProvider } from '@shared/hotel-itinerary/hotel-filters';
import { TypeGeneralWidget } from '@shared/widgets/components/general-widget/general-widget.enum';
import { WidgetsTypes } from '@shared/widgets/components/widgets-container/widgets-types.enum';
import { WidgetsPayload } from '@shared/widgets/entities/widgets';
import { ORIENTATION } from '@ux/constants/orientation.constants';
import {
  PercentagesBanner,
  BannerResultsContainer,
  BannerResultsType,
  HOTELS_BANNER_AVAILABLE,
  HOTELS_BANNER_ENABLED,
  HOTELS_BANNER_PERCENTAGES,
} from '@ux/mappers/banner-results.mapper';
import { AvoDispatchOrchestrator } from '@avo/orchestrator/avo.dispatch';
import { Component } from '@angular/core';
import { NavigationService } from '@app/services/navigation.service';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';
import { ChipFilterPriority } from '@design-system/components/molecules/chip-filter/entities/chip-filter.types';
import { TabType } from '@design-system/components/molecules/tab/entities/tab.types';

@Component({
  selector: 'app-hotel-result-base-abstract',
  template: '',
  standalone: false
})
export abstract class HotelResultsBaseAbstractComponent {

  public bannerContainer: BannerResultsContainer = BannerResultsContainer.HOTELS;
  public baseWidgets: string[] = [
    TypeGeneralWidget.PRICE_WIDGET,
    TypeGeneralWidget.AMMENITIES_WIDGET,
    TypeGeneralWidget.STARS_WIDGET
  ];
  public currentSource: EVENT_SOURCE = EVENT_SOURCE.RESULTS;
  public filtersProvider: HotelFilterProvider = HotelFilterProvider.HotelResults;
  public hotelsPrimeBanner: BannerResultsType = BannerResultsType.PRIME;
  public hotelsBanner: BannerResultsType = HOTELS_BANNER_AVAILABLE;
  public hotelsBannerEnabled: boolean = HOTELS_BANNER_ENABLED;
  public hotelsBannerPercentages: PercentagesBanner = HOTELS_BANNER_PERCENTAGES;
  public hotelsWidgetType: string = WidgetsTypes.HOTELS;
  public isFilterUp: boolean = false;
  public placeSearch: Place;
  public placeSelected: string;
  public searchPayload: WidgetsPayload = { Stars: [], Ammenities: [] };
  public showMapResultFilters: boolean = false;
  public showResultsMap: boolean = false;
  public topActionPosition: string = ORIENTATION.RIGHT;
  public widgets: string[];
  public inputDestinationPlace: InputDestinationPlace;
  public headerListCriteria: PlaceSelectors = PlaceSelectors.City;

  public readonly icons = Icon;
  public readonly iconFillColor = IconFillColor;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly chipFilterPriority = ChipFilterPriority.Secondary;

  public readonly tabType = TabType.Pill;

  protected AvoDispatch = new AvoDispatchOrchestrator();

  constructor(
    protected route: ActivatedRoute,
    protected navigationService: NavigationService,
  ) { }

  public get searchType(): SearchType {
    return this.isByHours ? SearchType.BYHOURS_RESULTS :  SearchType.HOTELS_RESULTS;
  }

  public get isByHours(): boolean {
    return this.route?.snapshot?.data?.['isByhour'];
  }

}
